/* unplugin-vue-components disabled */import { render } from "./NaturalDay.vue?vue&type=template&id=376b4f2d&scoped=true&ts=true"
import script from "./NaturalDay.vue?vue&type=script&lang=ts"
export * from "./NaturalDay.vue?vue&type=script&lang=ts"

import "./NaturalDay.vue?vue&type=style&index=0&id=376b4f2d&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-376b4f2d"]])

export default __exports__